import { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";

let cache = null;
let pending = null;
const subs = new Set();
const load = () => {
  if (!pending) {
    pending = api.get("/clients/riservati").then((r) => { cache = r.data || {}; subs.forEach((f) => f(cache)); }).catch(() => {}).finally(() => { pending = null; });
  }
  return pending;
};
if (typeof window !== "undefined") window.addEventListener("core-clients-changed", () => { cache = null; load(); });

export const useReservedNames = () => {
  const [map, setMap] = useState(cache || {});
  useEffect(() => {
    subs.add(setMap);
    if (!cache) load(); else setMap(cache);
    return () => subs.delete(setMap);
  }, []);
  return map;
};

export const ReservedLine = ({ clientId, names, className = "", testid }) => {
  const map = useReservedNames();
  const who = names || map[clientId];
  if (!who) return null;
  return (
    <span className={`inline-flex max-w-full items-center gap-1 text-[11px] font-bold text-[#0A1128] ${className}`} title={`Riservato a: ${who}`} data-testid={testid || `reserved-line-${clientId}`}>
      <Lock className="h-3 w-3 shrink-0 text-[#E8173A]" /><span className="truncate">Riservato a: {who}</span>
    </span>
  );
};
